import { createStandardAsyncAction } from 'utils/reduxUtils';

import { Group } from './types';

export const getGroup = createStandardAsyncAction(
  'group/GET_GROUP_REQUEST',
  'group/GET_GROUP_SUCCESS',
  'group/GET_GROUP_FAILURE'
)<undefined, Group, undefined>();
